import { useQueryParam } from '../../../hooks/useQueryParam';

export function useCurrentOfferId() {
  const currentOfferId = useQueryParam('offerId');

  return currentOfferId;
}
